import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { switchMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';

import { MwContactsApiService } from 'app/services/contact-api.service';
import * as contactsActions from '../actions/contacts.actions';
import * as notifyActions from 'app/store/general/actions/notify.actions';

@Injectable()
export class ContactsEffects {
  constructor(
    private actions$: Actions,
    private store$: Store<any>,
    private contactsApiService: MwContactsApiService
  ) {}

  loadContacts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(contactsActions.loadContacts),
      switchMap(({ loadOptions }) => {
        return this.contactsApiService.load(loadOptions).pipe(
          map((response) => contactsActions.loadContactsSuccess({ response })),
          catchError((error) =>
            of(contactsActions.loadContactsFailed({ error }))
          )
        );
      })
    )
  );

  createContact$ = createEffect(() =>
    this.actions$.pipe(
      ofType(contactsActions.createContact),
      switchMap(({ contact }) =>
        this.contactsApiService.create(contact).pipe(
          switchMap((createdContact) => [
            contactsActions.createContactSuccess({ contact: createdContact }),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.add_contact_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(contactsActions.createContactFailed({ error }))
          )
        )
      )
    )
  );

  updateContact$ = createEffect(() =>
    this.actions$.pipe(
      ofType(contactsActions.updateContact),
      switchMap(({ contact }) =>
        this.contactsApiService.update(contact).pipe(
          switchMap(() => [
            contactsActions.updateContactSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.update_contact_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(contactsActions.updateContactFailed({ error }))
          )
        )
      )
    )
  );

  deleteContacts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(contactsActions.deleteContact),
      switchMap(({ contact }) =>
        this.contactsApiService.delete(contact).pipe(
          switchMap(() => [
            contactsActions.deleteContactSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_contact_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(contactsActions.deleteContactFailed({ error }))
          )
        )
      )
    )
  );
}
